import { IndexSort } from "@omni/types/api/search/algolia/shared/enum/indexSort.enum";

export const ListItemConfig: Record<IndexSort, string> = {
    [IndexSort.Default]: "la-sort-amount-down", // Relevantie
    [IndexSort.PriceAsc]: "la-sort-numeric-down", // Prijs oplopend
    [IndexSort.PriceDesc]: "la-sort-numeric-up", // Prijs aflopend
    [IndexSort.OverallRatingDesc]: "la-sort-amount-down" // Beoordeling
};
